import { render } from "./ServicosRda.vue?vue&type=template&id=09565980"
import script from "./ServicosRda.vue?vue&type=script&lang=js"
export * from "./ServicosRda.vue?vue&type=script&lang=js"

import "./ServicosRda.vue?vue&type=style&index=0&id=09565980&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__